import React from 'react';
import { optionsForDoctor } from '../../utils/static-data/data';
import '../../components/profile-info/user-profile.scss';

const VisitSectionsSettingsTab = ({
    prescriptionSettingShowInfo,
    prescriptionSettingSetInfoFun,
    handlePrescriptionSubmit,
    isLoading,
}) => {
    const disabled = prescriptionSettingShowInfo?.disabledSections || [];

    const toggle = (id) => {
        const next = disabled.includes(id)
            ? disabled.filter((sectionId) => sectionId !== id)
            : [...disabled, id];
        prescriptionSettingSetInfoFun('disabledSections', next);
    };

    return (
        <div className="my-profile-layout prescription-settings-page">
            <div className="basic-info profile-panel prescription-settings-panel mb-2">
                <div className="profile-panel__toolbar">
                    <div>
                        <h2 className="profile-panel__title">Visit sections</h2>
                        <p className="profile-panel__subtitle">
                            Choose which sections appear in the left sidebar of the visit screen. Unchecked sections are hidden.
                        </p>
                    </div>
                    <button type="button" className="btn save-button" onClick={() => handlePrescriptionSubmit()}>
                        Save changes
                        {isLoading && (
                            <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true" />
                        )}
                    </button>
                </div>

                <div className="prescription-toggle-grid">
                    {optionsForDoctor.map((option) => (
                        <div
                            key={option.id}
                            className="prescription-toggle-row"
                            onClick={() => toggle(option.id)}
                        >
                            <input checked={!disabled.includes(option.id)} type="checkbox" tabIndex={-1} readOnly />
                            <label>{option.name}</label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default VisitSectionsSettingsTab;
